'use client'
import { type FC, memo } from 'react'
import styled from 'styled-components'
import { useModal, useTranslator } from '@/hooks'
import { MODALS } from '@/context'
import { mq, presets, rgbAlpha, vw } from '@/styles'
import { Button } from '../../base/Button'
import { CLIENT_NAME, getDynamicText } from '@/utils'

const headingId = 'subscribe'
export const SectionSubscribe:FC = memo(()=>{
  const { t } = useTranslator()
  const { toggle } = useModal(MODALS.AUTH)

  return(
    <Section aria-labelledby={headingId}>
      <hgroup>
        <h2 id={headingId}>{t('project.section_subscribe.title')}</h2>
        <p>{getDynamicText(t('project.section_subscribe.description') as string, { companyName: CLIENT_NAME })}</p>
      </hgroup>
      <ul>
        {(t('project.section_subscribe.member_benefits') as [string]).map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <Button type='button' onClick={toggle}  bgColor={'--color-text'} color='--color-gold'>
        {getDynamicText(t('project.section_subscribe.action') as string, { companyName: CLIENT_NAME })}
      </Button>
    </Section>
  )
})

// PENDING TO RE-DO whole CSS
const Section = styled.section`
  align-items: center;
  background-color: ${rgbAlpha('var(--color-background)', 0.5)};
  display: flex;
  flex-direction: column;
  height: ${vw(629, 'mobile')};
  grid-column: span 1 / span 6;
  margin: 0  0 ${vw(20, 'mobile')};
  padding: ${vw(60, 'mobile')}  ${vw(14, 'mobile')} ;

  ${mq.greaterThan('nexus7')} {
    height: ${vw(687, 'tablet')};
    margin: 0  0 ${vw(20, 'tablet')};
    padding: ${vw(60, 'tablet')}  ${vw(14, 'tablet')};
  }

  ${ mq.greaterThan('tablet') } {
    grid-column: 3 / span 8;
    height:  ${vw(687, 'desktop')};
    margin: 0 ${vw(50, 'desktop')};
    padding: ${vw(80, 'desktop')} ${vw(30, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    height: 687px;
    margin: 0 50px;
    padding: 80px 50px;
  }

    h2 {
      ${presets.font53}
      color: var(--color-text);
    }

    p {
      ${presets.font30}
      color: var(--color-text);
      font-weight: 400;
    }

    ul {
      margin: ${vw(50, 'mobile')};

      ${mq.greaterThan('nexus7')} {
        margin: ${vw(40, 'tablet')};
      }

      ${mq.greaterThan('tablet')} {
        margin: ${vw(40, 'desktop')};
      }

      ${mq.greaterThan('desktop')} {
        margin: 60px;
      }
    }


  h1,h2 {
    padding: 20px;
  }

  ul {
    text-align: center;

    ${mq.greaterThan('tablet')} {
      display: grid;
      grid-template-columns: ${vw(315, 'desktop')} auto;
      text-align: start;
    }

    li {
      ${presets.font15}
      color: var(--color-text);
      padding: ${vw(14, 'mobile')};

      ${mq.greaterThan('nexus7')} {
        padding: ${vw(14, 'tablet')};
      }

      ${mq.greaterThan('tablet')} {
        padding: ${vw(14, 'desktop')};
      }

      ${mq.greaterThan('desktop')} {
        padding: 14px;
      }

      &:before {
        color: var(--color-gold);
        content: "✓";
        display: inline-block;
        font-weight: 700;
        margin-left: -1.3em;
        width: 1.3em;
      }
    }
  }
`
